import React from "react";
import styled from "styled-components";
import { narrowScreenMediaQuery, white } from "../constants/styles";
import { unmodule } from "../util";
import { PopupableContext } from "../providers/ProvidePopupable";

export const UnnamedComponent = (props) => {
  const { title, body, children } = props;
  const { openModal, shownModal, handleClickOutsideModalEffect, closeModal } =
    React.use(PopupableContext);

  return (
    <React.Fragment>
      <div onClick={openModal}>{children}</div>
      {shownModal && (
        <ModalContainer onClick={handleClickOutsideModalEffect}>
          <ModalDialog
            onClick={(evt) => {
              evt.stopPropagation();
            }}
          >
            <ModalHeader>
              <Title>{title}</Title>
              <CloseImg
                src={unmodule(require("../images/icons/close.svg"))}
                tabIndex="0"
                onClick={closeModal}
              />
            </ModalHeader>
            <InnerSeparator />
            <ModalBody>{body}</ModalBody>
            <InnerSeparator />
            <ModalFooter></ModalFooter>
          </ModalDialog>
        </ModalContainer>
      )}
    </React.Fragment>
  );
};
export default UnnamedComponent;

const InnerSeparator = styled.div`
  background-color: #383939;
  height: 1px;
  margin-left: -20px;
  width: calc(100% + 40px);
  margin-top: 10px;
  margin-bottom: 10px;
`;

const ModalContainer = styled.div`
  background-color: #000000c7;
  color: ${white};
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 5;
`;

const ModalDialog = styled.div`
  background-color: #242424;
  border-radius: 5px;
  left: 50%;
  min-width: 700px;
  padding: 10px 20px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -70%);
  transition: all 0.1s;

  @media ${narrowScreenMediaQuery} {
    min-width: 300px;
    transform: translate(-50%, -50%);
  }
`;

const ModalHeader = styled.div`
  align-items: start;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  padding: 12px 0;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: bold;
`;

const ModalBody = styled.div`
  & > table {
    background-color: #2e2f30;
    width: 100%;
    border: 1px solid white;

    & th {
      padding: 15px;
      border-bottom: 1px solid #757575;

      &:not(:first-child) {
        border-left: 1px solid #757575;
      }
    }

    & td {
      padding: 15px;

      &:first-child {
        white-space: nowrap;
      }

      &:not(:first-child) {
        border-left: 1px solid #757575;
      }
    }

    & tr:not(:last-child) > td {
      border-bottom: 1px solid #595959;
    }
  }
`;

const ModalFooter = styled.div`
'`;

const CloseImg = styled.img`
  cursor: pointer;

  &:hover,
  &:active,
  &:focus {
    transform: translate(1px, 1px);
  }
`;
